import angular from 'angular';

import scrollspyComponentUrl from './scrollspyComponent.html';

/**
 * When scrolling to element on some browsers it better to scroll a tiny tad more so the
 * previous element in the scrollspy doesn't get highlighted
 */
const EPSILON = 5;

class ScrollspyCtrl {
  constructor(Utils, WindowScroll, $window, $location, $document, $timeout) {
    'ngInject';

    Object.assign(this, { Utils, WindowScroll, $window, $location, $document, $timeout });
  }

  $onChanges() {
    if (!this.offset) {
      this.offset = 0;
    }

    this.itemsArray = Object.entries(this.items || {}).map(([id, label]) => ({ id, label }));
  }

  async $onInit() {
    this._onScroll = () => {
      this.onScroll();
    };

    angular.element(this.$window).on('scroll', this._onScroll);

    const hash = this.$location.hash();
    if (hash in this.items) {
      await this.$timeout(0);
      this.scrollTo(hash);
    }
  }

  $onDestroy() {
    angular.element(this.$window).off('scroll', this._onScroll);
  }

  onScroll() {
    // to trigger digest when "stopped scrolling"
    this.Utils.debounce(() => {}, 500);
  }

  clicked(hash) {
    this.scrollTo(hash);
    this.$location.hash(hash);
  }

  scrollTo(hash) {
    const element = this.$document[0].getElementById(hash);
    if (!element) {
      return;
    }

    const { top } = element.getBoundingClientRect();

    const scrollTop = top + EPSILON + this.WindowScroll.y - this.offset;

    let verifyScrollHackCount = 10;
    const verifyScrollHack = () => {
      if (this.WindowScroll.y !== scrollTop && verifyScrollHackCount--) {
        this.$window.scrollTo(this.WindowScroll.x, scrollTop);
      } else {
        angular.element(this.$window).off('scroll', verifyScrollHack);
      }
    };

    /**
     * This is weird AF but for some inexplicable reason calling `scrollTo` doesn't
     * always position the scrollbar at the desired position. And calling it again
     * with the same argument after the scroll has been repositioned (`scroll` event fired)
     * helps. Just to make sure it doesn't explode we limit the "retries" to 10 iterations
     */
    angular.element(this.$window).on('scroll', verifyScrollHack);
    this.$window.scrollTo(this.WindowScroll.x, scrollTop);
  }

  isActive(id) {
    const firstVisibleItem = this.itemsArray
      .map((item) => {
        const element = this.$document[0].getElementById(item.id);
        if (!element) {
          return null;
        }

        return {
          ...item,
          bottom: element.getBoundingClientRect().bottom,
        };
      })
      .find((item) => item && item.bottom > this.offset);

    return firstVisibleItem && firstVisibleItem.id === id;
  }
}

export default {
  bindings: {
    items: '<',
    offset: '<?',
  },
  controllerAs: 'ctrl',
  controller: ScrollspyCtrl,
  templateUrl: scrollspyComponentUrl,
};
